import React from "react"
import { graphql, useStaticQuery } from "gatsby"

export default function SideBar() {
  const data = useStaticQuery(graphql`
    query ContactInfoQuery {
      datoCmsMenu {
        email
        phoneNumbers {
          label
          number
        }
        showrooms {
          id
          title
          information
        }
      }
    }
  `)

  const contact = data?.datoCmsMenu
  const showrooms = contact?.showrooms || []

  return (
    <div className='flex flex-col gap-32 m-flex-row m-mt32'>
      <div className='flex m-50 flex-col gap-32'>
        <div>
          <p>Email</p>
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
        </div>
        <div>
          <p>Phone</p>
          <div className='flex flex-col gap-20'>
          {contact.phoneNumbers?.map(phone => (
            <div>
              <p className='op-50'>{phone.label}</p>
              <a href={`tel:${phone.number}`}>{phone.number}</a>
            </div>
          ))}
          </div>
        </div>
      </div>
      <div className='flex m-50 flex-col gap-32'>
        <div className='flex flex-col gap-16'>
          <p>Showrooms</p>
          {showrooms.map(showroom => (
            <div key={showroom.id}>
              <p className='op-50'>{showroom.title}</p>
              <div>
                <div className='white-space' dangerouslySetInnerHTML={{ __html: showroom.information }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
